import React from 'react'

export const NoScriptFallback: React.FC = () => {
  return (
    <noscript>
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e0f2fe 50%, #e0e7ff 100%)',
        padding: '2rem',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          background: 'white',
          borderRadius: '1rem',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden'
        }}>
          {/* Header */}
          <div style={{
            background: 'linear-gradient(90deg, #2563eb 0%, #4f46e5 100%)',
            padding: '2rem',
            color: 'white'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{
                width: '3rem',
                height: '3rem',
                background: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem'
              }}>
                <img
                  src="/mernaki-32.png"
                  alt="Mernaki Logo"
                  style={{
                    width: '1.5rem',
                    height: '1.5rem',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <div>
                <h1 style={{ margin: '0', fontSize: '2rem', fontWeight: 'bold' }}>
                  Mernaki
                </h1>
                <p style={{ margin: '0.5rem 0 0 0', opacity: 0.9 }}>
                  Unified Business Platform
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div style={{ padding: '2rem' }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '1rem'
            }}>
              JavaScript Required
            </h2>

            <p style={{
              fontSize: '1.125rem',
              color: '#4b5563',
              lineHeight: '1.6',
              marginBottom: '2rem'
            }}>
              This application requires JavaScript to function properly. Please enable JavaScript in your browser to access all features and services.
            </p>

            {/* Services Overview */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '1rem'
              }}>
                Our Services:
              </h3>

              <div style={{
                display: 'grid',
                gap: '1rem',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))'
              }}>
                {/* HR Service */}
                <div style={{
                  padding: '1.5rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.5rem',
                  background: '#f9fafb'
                }}>
                  <h4 style={{
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    color: '#10b981',
                    marginBottom: '0.5rem'
                  }}>
                    👥 HR Templates
                  </h4>
                  <p style={{
                    color: '#6b7280',
                    fontSize: '0.875rem',
                    lineHeight: '1.4',
                    margin: '0'
                  }}>
                    Professional recruitment page templates starting from €1,000
                  </p>
                </div>

                {/* Compliance Service */}
                <div style={{
                  padding: '1.5rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.5rem',
                  background: '#f9fafb'
                }}>
                  <h4 style={{
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    color: '#f59e0b',
                    marginBottom: '0.5rem'
                  }}>
                    🛡️ Compliance (Coming Soon)
                  </h4>
                  <p style={{
                    color: '#6b7280',
                    fontSize: '0.875rem',
                    lineHeight: '1.4',
                    margin: '0'
                  }}>
                    EU recall insurance and legal compliance services
                  </p>
                </div>

                {/* Trade Service */}
                <div style={{
                  padding: '1.5rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.5rem',
                  background: '#f9fafb'
                }}>
                  <h4 style={{
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    color: '#8b5cf6',
                    marginBottom: '0.5rem'
                  }}>
                    🌍 Trade (Coming Soon)
                  </h4>
                  <p style={{
                    color: '#6b7280',
                    fontSize: '0.875rem',
                    lineHeight: '1.4',
                    margin: '0'
                  }}>
                    Rare-earth export permits and international trade support
                  </p>
                </div>

                {/* Intelligence Service */}
                <div style={{
                  padding: '1.5rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.5rem',
                  background: '#f9fafb'
                }}>
                  <h4 style={{
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    color: '#06b6d4',
                    marginBottom: '0.5rem'
                  }}>
                    🧠 Intelligence (Coming Soon)
                  </h4>
                  <p style={{
                    color: '#6b7280',
                    fontSize: '0.875rem',
                    lineHeight: '1.4',
                    margin: '0'
                  }}>
                    AI-powered market intelligence and hiring insights
                  </p>
                </div>
              </div>
            </div>

            {/* How to Enable JavaScript */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '1rem'
              }}>
                How to Enable JavaScript:
              </h3>

              <div style={{
                background: '#f3f4f6',
                padding: '1.5rem',
                borderRadius: '0.5rem',
                border: '1px solid #d1d5db'
              }}>
                <ul style={{
                  margin: '0',
                  paddingLeft: '1.5rem',
                  color: '#4b5563',
                  lineHeight: '1.6'
                }}>
                  <li style={{ marginBottom: '0.5rem' }}>
                    <strong>Chrome:</strong> Settings → Privacy and security → Site Settings → JavaScript → Allowed
                  </li>
                  <li style={{ marginBottom: '0.5rem' }}>
                    <strong>Firefox:</strong> about:config → javascript.enabled → true
                  </li>
                  <li style={{ marginBottom: '0.5rem' }}>
                    <strong>Safari:</strong> Preferences → Security → Enable JavaScript
                  </li>
                  <li>
                    <strong>Edge:</strong> Settings → Site permissions → JavaScript → Allowed
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Information */}
            <div style={{
              background: '#eff6ff',
              border: '1px solid #bfdbfe',
              borderRadius: '0.5rem',
              padding: '1.5rem'
            }}>
              <h3 style={{
                fontSize: '1.125rem',
                fontWeight: '600',
                color: '#1e40af',
                marginBottom: '1rem'
              }}>
                Need Help?
              </h3>
              <p style={{
                color: '#1e40af',
                margin: '0 0 1rem 0',
                lineHeight: '1.5'
              }}>
                If you're having trouble enabling JavaScript or need immediate assistance:
              </p>
              <div style={{ color: '#1e40af' }}>
                <p style={{ margin: '0.5rem 0' }}>
                  📧 Email: <a href="mailto:support@mernaki.de" style={{ color: '#1d4ed8', textDecoration: 'underline' }}>support@mernaki.de</a>
                </p>
                <p style={{ margin: '0.5rem 0' }}>
                  📞 Phone: +49 (0) 123 456 789
                </p>
                <p style={{ margin: '0.5rem 0' }}>
                  📍 Location: Berlin, Germany
                </p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{
            background: '#f9fafb',
            borderTop: '1px solid #e5e7eb',
            padding: '1.5rem',
            textAlign: 'center'
          }}>
            <p style={{
              margin: '0',
              color: '#6b7280',
              fontSize: '0.875rem'
            }}>
              © 2026 Mernaki. All rights reserved. |
              <a href="mailto:support@mernaki.de" style={{
                color: '#2563eb',
                textDecoration: 'underline',
                marginLeft: '0.5rem'
              }}>
                Contact Support
              </a>
            </p>
          </div>
        </div>
      </div>
    </noscript>
  )
}